$(document).ready(function() {
  $('.main-navigation a.disable').click(function(event) {
    event.preventDefault();
  })
});
//
